import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4MainDispatch from '../Bs4MainDispatch';
import { ButtonGroupStyled, ButtonStyled, MenuItemStyled, IconButtonStyled } from './Bs4MenuStyled';

// Ma wywoływać request bs4OpenCard podobnie jak obecnie trybik do edycji elementu formularza. 
// allparams: {"currFormId":"5000364","targetObject":"5000364","targetOption":298,"currCardViewId":"64c937d55612e9.16109148","currOptionId":"329"}
// z tym wyjątkiem, że powyżej w:
// targetOption ma być sztywno 300
// w targetObject ma być id strony/opcji przy której kliknięto w menu.

export default function Bs4MenuGearIcon (props) {

  const handleClick = (event) => {
    event.stopPropagation();
    //console.log('... Menu Click Gear ...', props, (props.targetOption || 305));
    const details = {currFormId: props.item.bs4Id, targetObject: props.item.bs4Id, targetOption: (props.targetOption || 305)};  //305
    Bs4MainDispatch.commandParser('Bs4OpenCard', details, props.bs4KartotekaId);
  }

  if (!props?.bs4ConstructorMode) return null;
  if (!props?.item?.bs4Id) return null;

  return (
    <IconButton
      onClick={handleClick} 
      sx={{
        fontSize: 12, 
        color: 'inherit',
        backgroundColor: 'inherit',
      }}      
    >
      <i className="fa-solid fa-gear"/>
    </IconButton>
  )
}

export function Bs4MenuGearButton (props) {

  const handleClick = (event) => {
    event.stopPropagation();
    //console.log('... Menu Click Gear ...', props, (props.targetOption || 305));
    const details = {currFormId: props.item.bs4Id, targetObject: props.item.bs4Id, targetOption: (props.targetOption || 305)};  //305
    Bs4MainDispatch.commandParser('Bs4OpenCard', details, props.bs4KartotekaId);
  }

  if (!props?.bs4ConstructorMode) return null;
  if (!props?.item?.bs4Id) return null;

  return (
    <ButtonStyled
      onClick={handleClick} 
      sx={{
        fontSize: 12, 
        color: 'inherit',
        backgroundColor: 'inherit',
        padding: 1,
        minWidth: 0,
        '.MuiButtonGroup-grouped': {
          padding: 0.5,
          minWidth: 0,
        },
        '&.MuiButtonGroup-grouped': {
          padding: 0.5,
          minWidth: 0,
        },
        '& .MuiButtonGroup-grouped': {
          padding: 0.5,
          minWidth: 0,
        }
      }}      
    >
      <i className="fa-solid fa-gear"/>
    </ButtonStyled>
  )
}